import { BaseService } from './base.service';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ResultApi } from '../viewModel/result_api.model';
import { Hotel } from '../viewModel/hotel';
import { FiltroHotel } from '../viewModel/filtro_hotel.model';
import { FiltroAvancadoBody } from '../viewModel/filtro_hotel_body.model';
import {HOTEIS_DESTAQUES, HOTEL_HIGHLIGHTS} from '../constants/hoteis-destaques.constants';

@Injectable({ providedIn: 'root' })
export class HotelService extends BaseService {

    constructor(private httpClient: HttpClient) {
        super(httpClient, 'hotelaria');
    }

    public fetchHotelsStaticHighlights() {
        return {
            status: 200,
            data: HOTEL_HIGHLIGHTS,
            error: false,
            description: '',
        };
    }

    public buscaHoteisDestaqueEstatico(tipoDestaque: number, tipoPagina: string = 'home') {
        const hoteisDestaque = HOTEIS_DESTAQUES.filter(item => item.tipoDestaque === tipoDestaque);
        const hotelHighlights = HOTEL_HIGHLIGHTS.filter(item => item.tipoDestaque === tipoDestaque);
        return {
            status: 200,
            data: tipoPagina === 'home' ? hoteisDestaque : hotelHighlights,
            error: false,
            description: '',
        };
    }

    public async buscaHoteisDestaque(tipoDestaque: number): Promise<ResultApi> {
        try {
            const httpOptions = await this.getHttpOptions();
            if (this.hasToken()) {
                return this.httpClient
                    .get<Hotel>(`${this.path()}/hoteis-destaque?tipoDestaque=${tipoDestaque}`, httpOptions)
                    .toPromise()
                    .then((res: any) => this.response(this.changeImage(res, true)))
                    .catch((err: any) => err);
            }

        } catch (e) {
            return null;
        }
    }

    public async buscaHoteisAutoComplete(pesquisa: string): Promise<ResultApi> {
        try {
            const httpOptions = await this.getHttpOptions();
            if (this.hasToken()) {
                return this.httpClient
                    .get<any>(`${this.path()}/autocomplete?pesquisa=${pesquisa}`, httpOptions)
                    .toPromise()
                    .then((res: any) => this.response(res))
                    .catch((err: any) => err);
            }
        } catch (e) {
            return null;
        }
    }

    public async listaHoteis(body: any): Promise<ResultApi> {
        try {
            if (body.codBairro !== '' && body.codBairro !== null && body.codBairro !== undefined) {
                body.bairro = body.codBairro;
            }
            const httpOptions = await this.getHttpOptions();
            if (this.hasToken()) {
                return this.httpClient
                    .post<any>(`${this.path()}/hoteis-site`, body, httpOptions)
                    .toPromise()
                    .then((res: any) => {
                        if (res) {
                            res.hoteis = this.changeImage(res.hoteis, true);
                            return new ResultApi().toResult({ status: 202, data: res, error: null });
                        }
                        return null;
                    })
                    .catch((err: any) => err);
            }
        } catch (e) {
            return null;
        }

    }

    public async listaHoteisAvancado(filtro: any, filtroAvancado: FiltroHotel) {
        try {
            const filtroConsolidado = this.getFiltroAvancado(filtro, filtroAvancado);
            return await this.hoteisAvancado(filtroConsolidado);
        } catch (err) {
            return null;
        }
    }

    public async filtroAvancado(body: any): Promise<ResultApi> {
        try {
            const httpOptions = await this.getHttpOptions();
            if (this.hasToken()) {
                return this.httpClient
                    .post<FiltroHotel>(`${this.path()}/filtro-avancado`, body, httpOptions)
                    .toPromise()
                    .then((res: any) => this.response(res))
                    .catch((err: any) => err);
            }
        } catch (e) {
            return null;
        }
    }

    public async buscaPorCodContratoEstatico(codContrato: number) {
        const HOTELS = [...HOTEIS_DESTAQUES, ...HOTEL_HIGHLIGHTS];
        const data = HOTELS.find(item => item.codContrato === codContrato);
        return {
            status: 200,
            data,
            error: false,
            description: '',
        };
    }
    public async buscaPorCodContrato(codContrato: number): Promise<ResultApi> {
        try {
            const httpOptions = await this.getHttpOptions();
            if (this.hasToken()) {
                return this.httpClient
                    .get<any>(`${this.path()}/hotel/${codContrato}`, httpOptions)
                    .toPromise()
                    .then((res: any) => this.response(this.changeImage(res, false)))
                    .catch((err: any) => err);
            }
        } catch (e) {
            return null;
        }
    }

    public async getCountFiltrosSelecionados(data: any) {
        let countFiltros = 0;
        try {
            if (data.tipoPlano) {
                countFiltros += this.setCountFilter(data, 'tipoPlano');
            }
            if (data.tipoHotel) {
                countFiltros += this.setCountFilter(data, 'tipoHotel');
            }
            if (data.tipoQuarto) {
                countFiltros += this.setCountFilter(data, 'tipoQuarto');
            }
            if (data.tipoApartamento) {
                countFiltros += this.setCountFilter(data, 'tipoApartamento');
            }
            if (data.regimesAlimentacao) {
                countFiltros += this.setCountFilter(data, 'regimesAlimentacao');
            }
            if (data.bairro) {
                countFiltros += this.setCountFilter(data, 'bairro');
            }
            if (data.cidade) {
                countFiltros += this.setCountFilter(data, 'cidade');
            }
            if (data.estado) {
                countFiltros += this.setCountFilter(data, 'estado');
            }
            if (data.comodidades) {
                countFiltros += this.setCountFilter(data, 'comodidades');
            }
            return countFiltros;
        } catch (err) {
            return 0;
        }
    }

    public ordernarPlanosFacilita(data: any) {
        if (data.tipoPlano !== null && data.tipoPlano !== undefined) {
            if (data.tipoPlano.itens.length > 0) {
                data.tipoPlano.itens.sort((a, b) => {
                    if (+a.id > +b.id) {
                        return 1;
                    } else if (+a.id < +b.id) {
                        return -1;
                    } else {
                        return 0;
                    }
                });
            }
        }
        return data;
    }

    public getFiltroAvancado(filtro: any, filtroAvancado: FiltroHotel) {
        const filtroAvancadoBody = new FiltroAvancadoBody();
        filtroAvancadoBody.numeroPagina = filtro.numeroPagina;
        filtroAvancadoBody.qtdPorPagina = filtro.qtdPorPagina;

        filtroAvancado.regimesAlimentacao.itens.forEach((item) => {
            if (item.checked) {
                filtroAvancadoBody.regimesAlimentacao.push(item.id);
                filtroAvancadoBody.regimeAlimentacao.push(item.id);
            }
        });

        if (filtro.tipoApartamento) {
            filtro.tipoApartamento.forEach(item => {
                filtroAvancadoBody.tipoApartamento.push(item);
            });
        }

        filtroAvancado.tipoApartamento.itens.forEach((item) => {
            if (item.checked) {
                filtroAvancadoBody.tipoApartamento.push(item.id);
            }
        });


        filtroAvancado.tipoHotel.itens.forEach((item) => {
            if (item.checked) {
                filtroAvancadoBody.tipoHotel.push(item.id);
            }
        });


        filtroAvancado.criancaGratis.itens.forEach((item) => {
                if (item.checked) {
                    filtroAvancadoBody.criancaGratis.push(item.id);
                }
            });


        filtroAvancado.hotel.itens.forEach((item) => {
                if (item.checked) {
                    filtroAvancadoBody.hotel.push(item.id);
                }
            });

        filtroAvancado.tipoQuarto.itens.forEach((item) => {
            if (item.checked) {
                filtroAvancadoBody.tipoQuarto.push(item.id);
            }
        });

        if (filtro.tipoComodidade) {
            filtro.tipoComodidade.forEach(item => {
                filtroAvancadoBody.tipoComodidade.push(Number(item));
            });
        }

        filtroAvancado.comodidades.forEach((itemComodidade) => {
            itemComodidade.comodidades.forEach((item) => {
                if (item.checked) {
                    filtroAvancadoBody.comodidades.push(item.id.toString());
                }
            });
        });

        if (filtro.codPais) {
            filtroAvancadoBody.codPais = filtro.codPais;
        }

        if (filtro.codEstado) {
            filtroAvancadoBody.codEstado = filtro.codEstado;
        } else {
            filtroAvancado.estado.itens.forEach((item) => {
                if (item.checked) {
                    filtroAvancadoBody.codEstado = item.id;
                }
            });
        }

        if (filtro.codCidade) {
            filtroAvancadoBody.codCidade = Number(filtro.codCidade);
        } else {
            filtroAvancado.cidade.itens.forEach((item) => {
                if (item.checked) {
                    filtroAvancadoBody.codCidade = Number(item.id);
                }
            });
        }

        if (filtro.bairro) {
            filtroAvancadoBody.bairro = filtro.bairro;
        } else {
            filtroAvancado.bairro.itens.forEach((item) => {
                if (item.checked) {
                    filtroAvancadoBody.bairro = item.descricao;
                }
            });
        }
        if (filtro.tipoPlano) {
            filtroAvancadoBody.tipoPlano = filtro.tipoPlano;
        } else {
            filtroAvancado.tipoPlano.itens.forEach((item) => {
                if (item.checked) {
                    filtroAvancadoBody.tipoPlano.push(item.id);
                }
            });
        }

        return filtroAvancadoBody;
    }

    private async hoteisAvancado(filtroAvancado: FiltroAvancadoBody): Promise<ResultApi> {
        try {
            const httpOptions = await this.getHttpOptions();
            if (this.hasToken()) {
                return this.httpClient
                    .post<any>(`${this.path()}/hoteis-site`, filtroAvancado, httpOptions)
                    .toPromise()
                    .then((res: any) => {
                        if (res) {
                            res.hoteis = this.changeImage(res.hoteis, true);
                            return new ResultApi().toResult({ status: 202, data: res, error: null });
                        }
                        return null;
                    })
                    .catch((err: any) => err);
            }

        } catch (e) {
            return null;
        }
    }

    private setTypeFilter(body: any, data: any, typeName: string ) {
        if (typeName === 'comodidades') {
            data[typeName].forEach(item => {
                item[typeName].forEach(subItem => {
                    body[typeName].forEach(element => {
                        if (element === subItem.id.toString()) {
                            subItem.checked = true;
                        }
                    });
                });
            });
            return data;
        }
        if (typeName === 'bairro') {
            data[typeName].itens.forEach(item => {
                if (body[typeName] === item.descricao) {
                    item.checked = true;
                }
            });
            return data;
        }
        data[typeName].itens.forEach(item => {
            body[typeName].forEach(element => {
                if (element === item.id) {
                    item.checked = true;
                }
            });
        });
        return data;
    }

    private setCountFilter(data: any, typeName: string ) {
        return data[typeName].length;
    }

    private changeImage(hoteis: any, isArray: boolean) {
        if (isArray) {
            const data = [];
            hoteis.forEach(item => {
                item.fotos = this.replaceImage(item.fotos);
                data.push(item);
            });
            hoteis = data;
            return this.setAlts(hoteis);
        }
        hoteis.fotos = this.replaceImage(hoteis.fotos);
        return this.setAlt(hoteis);
    }

    private replaceImage(fotos: []) {
        const dataFoto = [];
        fotos.forEach((foto: any) => {
            foto = foto.replace('https://sistemas.montrealonline.com.br/', 'http://imagens.viagensmontreal.com/');
            dataFoto.push(foto);
        });
        return dataFoto;
    }

    setAlt(hotel: any) {
        hotel.alt = `Montreal Viagens - ${hotel.nome}`;
        return hotel;
    }
    public setAlts(hoteis: any[]) {
        return hoteis.map(element => this.setAlt(element));
    }
}
